// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iNMf","title":"styles_title__Hwbz-"};